import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import ServiceBody from "../../ServiceComponents/ServiceBody";

import { FaGreaterThan } from "react-icons/fa6";

import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";
import PathologyMainSection from "../../PageElements/PathologyPageElement/PathologyMainSection";

export default function PathologyPage() {
    return (
        <>
            <ServiceHeader
                childClass="pathologyBGSection"
                breadcrumb={<>Services <FaGreaterThan size={15} /> Pathology</>}
                title="Pathology"
            />

            <PathologyMainSection/>

            {/* <ServiceBody
                serviceName="Pathology"
            /> */}
            {/* <ServiceSection /> */}
            {/* <ConsultSection /> */}
        </>
    )
}